var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onCreate
    }
  }, [_vm._v("创建新资产")]), _c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm.isLoading ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)]), _c('div', {
    staticClass: "search-box btns"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 分类： "), _c('select', {
    on: {
      "change": function ($event) {
        return _vm.onChange($event.target.value);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _vm._l(_vm.assetsChains, function (item, index) {
    return _c('option', {
      domProps: {
        "value": item.id,
        "selected": item.id == _vm.chain_id && 'selected'
      }
    }, [_vm._v(_vm._s(item.id))]);
  })], 2)]), _c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm.isLoading ? [_vm._v("查询中...")] : [_vm._v("查询")]], 2)]), _c('div', {
    staticClass: "task-list"
  }, [_vm._m(0), _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      staticClass: "task-list-item"
    }, [_c('div', {
      staticClass: "s id"
    }, [_vm._v(" " + _vm._s(item.id) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.chain) + " ")]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.symbol) + " ")]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('div', {
      staticClass: "s icon"
    }, [item.icon ? _c('img', {
      attrs: {
        "src": item.icon,
        "height": "30px"
      }
    }) : _vm._e()]), _c('div', {
      staticClass: "s status",
      class: `status_${item.depositable}`
    }, [_vm._v(" " + _vm._s(item.depositable == 0 ? '否' : '是') + " ")]), _c('div', {
      staticClass: "s status",
      class: `status_${item.withdrawable}`
    }, [_vm._v(" " + _vm._s(item.withdrawable == 0 ? '否' : '是') + " ")]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.withdraw_send_type == 0 ? '用户自取' : '官方代发') + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.withdraw_service_fee) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.withdraw_min_amount) + " ")]), _c('div', {
      staticClass: "s label"
    }, [item.proof_url ? _c('a', {
      attrs: {
        "href": item.proof_url,
        "target": "_blank"
      }
    }, [item.proof_button_image ? _c('img', {
      attrs: {
        "src": item.proof_button_image,
        "height": "30px"
      }
    }) : _vm._e()]) : _vm._e()]), _c('div', {
      staticClass: "s status",
      class: `status_${item.status}`
    }, [_vm._v(" " + _vm._s(item.status == 0 ? '禁用' : '启用') + " ")]), _c('div', {
      staticClass: "s sort"
    }, [_vm._v(" " + _vm._s(item.sort) + " ")]), _c('div', {
      staticClass: "s create"
    }, [_vm._v(" " + _vm._s(_vm.cutStr(item.created_at)) + " ")]), _c('div', {
      staticClass: "s opt"
    }, [_c('div', {
      staticClass: "btn",
      on: {
        "click": function ($event) {
          return _vm.onModify(item);
        }
      }
    }, [_vm._v("编辑")])])]);
  })], 2), _c('pop-assets-tokens', {
    attrs: {
      "show": _vm.popAssetsTokensShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popAssetsTokensShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-list-item"
  }, [_c('div', {
    staticClass: "s id"
  }, [_vm._v(" 编号 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 链 ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 符号 ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 名称 ")]), _c('div', {
    staticClass: "s icon"
  }, [_vm._v(" ICON ")]), _c('div', {
    staticClass: "s status"
  }, [_vm._v(" 可充值 ")]), _c('div', {
    staticClass: "s status"
  }, [_vm._v(" 可提现 ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 提现方式 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 提现手续费（TON） ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 最小提现金额 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 链上证明 ")]), _c('div', {
    staticClass: "s status"
  }, [_vm._v(" 状态 ")]), _c('div', {
    staticClass: "s sort"
  }, [_vm._v(" 排序 ")]), _c('div', {
    staticClass: "s create"
  }, [_vm._v(" 添加时间 ")]), _c('div', {
    staticClass: "s opt"
  })]);
}];
export { render, staticRenderFns };